import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import SmoothScroll from "@/components/SmoothScroll";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { CookieConsent } from "@/components/CookieConsent";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Legal from "@/pages/Legal";
import PaymentReturn from "@/pages/PaymentReturn";
import AffiliateRedirect from "@/pages/AffiliateRedirect";
import AdminDashboard from "@/pages/AdminDashboard";
import CreatorDashboard from "@/pages/CreatorDashboard";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <SmoothScroll>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/privacy" element={<Legal type="privacy" />} />
                <Route path="/cookie" element={<Legal type="cookie" />} />
                <Route path="/termini" element={<Legal type="terms" />} />
                <Route path="/acquisto" element={<PaymentReturn />} />
                <Route path="/r/:handle" element={<AffiliateRedirect />} />
                <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
                <Route path="/creator" element={<ProtectedRoute role="creator"><CreatorDashboard /></ProtectedRoute>} />
              </Routes>
            </SmoothScroll>
            <CookieConsent />
          </BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
